import { ListItemButton, ListItemIcon, useTheme } from "@mui/material";
import { ChevronRight } from "lucide-react";
import type { FC } from "react";
import type { TimelineItemCategoryEnum } from "web_myplann/Infrastructure/Api/Api";
import { CategoryIcon } from "web_myplann/Shared/Components/CategoryIcon";
import { EventRowContent } from "web_myplann/Shared/Components/EventRowContent";
import type { EventRowLines } from "web_myplann/Shared/Types/EventRowLines";

type Props = EventRowLines & {
	category: TimelineItemCategoryEnum;
	showDivider: boolean;
	onClick: () => void;
};

export const EventRow: FC<Props> = ({
	category,
	showDivider,
	onClick,
	...lines
}) => {
	const { palette, iconSize, activity } = useTheme();

	return (
		<ListItemButton
			variant="row"
			disableRipple
			divider={showDivider}
			alignItems="flex-start"
			onClick={onClick}
		>
			<ListItemIcon sx={{ minWidth: 0, mt: 0 }}>
				<CategoryIcon item={{ category }} />
			</ListItemIcon>
			<EventRowContent {...lines} />
			<ChevronRight
				size={iconSize.sm}
				color={palette.grey[400]}
				style={{ flexShrink: 0, marginTop: activity.eventRow.chevronOffset }}
			/>
		</ListItemButton>
	);
};
